import React from "react";
import { Container } from "../styles/global";
import ContactForm from "../components/contact/ContactForm";


const Contact = () => {
  // const handleSubmit = async () => {
  //   try {
  //     let Data = JSON.stringify(values);
  //     const postData = await axios.post(
  //       "https://sheet.best/api/sheets/c07db96e-219d-416e-8be4-1ebce375fe3d",
  //       values
  //     );
  //     console.log(postData);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  return (
    <Container>
      <img src="assest/images/sectionHeaders/contact.png" alt="contact" />
      <div id="contact" className="mt-10 p-0 md:p-14 py-0">
        <ContactForm />
      </div>
    </Container>
  );
};

export default Contact;
